/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

import {useEffect, useState} from 'react';

/**
 * Hook to get the URL for a {@link File} object.
 *
 * @param obj The object to get the URL for
 * @return The URL string
 */
export function useObjectUrl(obj: File): string | undefined {
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    const url = URL.createObjectURL(obj);
    // Disable lint rule. An effect is the simplest way to write this.
    // Avoiding the effect makes implementing cleanup harder.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [obj]);

  return url;
}
